module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admins/admin/admin.component.css
// module id = ./src/app/admins/admin/admin.component.css
// module chunks = main